export const userEndpoints = {
  user: {
    signup: {
      url: 'account/signup',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    logout: {
      url: 'account/logout',
      version: 'v1',
      method: 'get',
      options: {
        headers: {
          'Content-Type': 'application/json',
          account_type: 'a',
        },
      },
    },
    startLogout: {
      url: 'account/oauth_logout_start',
      version: 'v1',
      method: 'get',
      options: {
        headers: {
          'Content-Type': 'application/json',
          account_type: 'a',
        },
      },
    },
    checkLogin: {
      url: 'account/check_login',
      version: 'v1',
      method: 'get',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    login: {
      url: 'account/login',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
          account_type: '',
        },
      },
    },
    // login: {
    //   url: 'account/oauth_login_start',
    //   version: 'v1',
    //   method: 'get',
    //   options: {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       account_type: 'a',
    //     },
    //   },
    // },
    loginCompleted: {
      url: 'account/oauth_login_complete',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
          account_type: 'a',
        },
      },
    },
    loginToken: {
      url: 'account/external_token/get',
      version: 'v1',
      method: 'get',
      options: { headers: { 'Content-Type': 'application/json' } },
    },
    delete: {
      url: 'account/delete',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    requestPasswordReset: {
      url: 'account/password/request_reset',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    verifyPasswordToken: {
      url: 'account/password/verify_code',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    resetPassword: {
      url: 'account/password/reset',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    edit: {
      url: 'account/edit',
      version: 'v1',
      method: 'post',
      options: {},
    },
  },
};
